// src/modules/app-views/_apps/appmulti/leads/pages/Init/components/tableColumns/nameColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';
import { parsePhoneToDisplay } from 'utils/helpers';

// *******************************************************************************
// COLUMN FUNCTION
// Name + email + phone two-line cell (mirrors backup List.jsx contact display)
// *******************************************************************************
function nameColumn(buildColumnProps) {
  return {
    key: 'name',
    title: translateX('name'),
    dataIndex: 'name',
    className: 'text-truncate',
    ...buildColumnProps('name', { sort: true, search: true }),
    render: (_, record) => (
      <div className="line-height-md">
        <div className="font-weight-semibold">{record?.name || '—'}</div>
        <div className="text-muted font-size-sm">
          {record?.email}
          {record?.phone ? ` · ${parsePhoneToDisplay(record.phone)}` : ''}
        </div>
      </div>
    ),
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default nameColumn;
